<template>
  <div id="FUNHIW" class="ACD18 text-NotoSansRegular mx-auto">
    <div class="banner px-4">
      <div class="py-5 max-w-6xl mx-auto">
        <router-link :to="{ name: 'index' }" class="block">
          <img class="object-contain h-6" src="~@/assets/images/FUNHIW/logo.png" alt="livaABC">
        </router-link>
      </div>
    </div>
    <nav class="nav">
      <ul class="flex flex-wrap justify-center items-center text-base menu-blue">
        <li class="flex-1-c md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toPlan">訂閱方案</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1-c md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toFeature">內容特色</a>
        </li>
        <li class="text-sm hidden md:block">|</li>
        <li class="flex-1-c md:flex-initial hidden md:flex">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toReader">讀者見證</a>
        </li>
        <li class="text-sm hidden md:block">|</li>
        <li class="flex-1-c md:flex-initial hidden md:block">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toRecommend">名師推薦</a>
        </li>
        <li class="text-sm hidden md:block">|</li>
        <li class="flex-1-c md:flex-initial hidden md:block">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="tosShow">精彩試閱</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1-c md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toBuyAdd">好康加購</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1-c md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toBuyInstance">立即訂購</a>
        </li>
      </ul>
    </nav>
    <div class="main-banner">
      <img src="~@/assets/images/FUNHIW/banner.png" class="object-contain max-w-full w-full hidden sm:block">
      <img src="~@/assets/images/FUNHIW/banner1.png" class="object-contain max-w-full w-full sm:hidden">
    </div>
    <div class="sub-standard w-full justify-center items-center py-4 lg:py-6 flex-wrap">
      <!-- <div>
        <h3 class="md:flex text-xl md:text-2xl lg:text-3xl items-center font-black tracking-wider">
          <span class="text mr-2">訂再送FoodPanda百元折價券</span>
          <span class="text-white">現在就帶回家!!</span>
        </h3>
        <hr class="border-white hidden md:block">
      </div>
      <img class="object-contain h-12 md:h-20 mx-3" src="~@/assets/images/FUNHIW/moto.png" alt="livaABC"> -->
    </div>
    <main>
      <!-- 雜誌內容特色 -->
      <section class="feature bg-white py-6" id="feature">
        <div class="max-w-5xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">雜誌內容特色</h5>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 px-2">
              <h6 class="text-2xl second-title font-semibold">這是一本全家大小</h6>
              <h6 class="text-2xl second-title font-semibold">都看得懂得科普雜誌！</h6>
              <p class="leading-loose text-gray-main">※ 統測、學測必備，專家編寫，考題命中率超高！</p>
              <p class="leading-loose text-gray-main">※ 符合108課綱，將科普知識落實於生活中！</p>
              <p class="leading-loose text-gray-main">※ STEAM跨域學習，搭上最火教育趨勢！</p>
              <p class="leading-loose text-gray-main">※ 取材生活，全彩圖解，科普知識一看就懂！</p>
              <p class="leading-loose text-gray-main">※ 英國FUTURE集團獨家授權，歐美專家編寫！</p>
            </div>
            <div class="w-full md:w-1/2 flex items-center px-2">
              <img class="object-contain" src="~@/assets/images/FUNHIW/family.png" alt="livaABC">
            </div>
          </div>
        </div>
      </section>
      <!-- 訂閱活動方案 -->
      <section class="plan py-6" id="plan">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">訂閱活動方案</h5>
          </div>
          <div class="flex flex-wrap mb-6">
            <div class="w-full md:w-1/3 p-2 md:p-3">
              <img class="object-contain" src="~@/assets/images/FUNHIW/price-1790.png" alt="livaABC">
            </div>
            <div class="w-full md:w-1/3 p-2 md:p-3">
              <img class="object-contain" src="~@/assets/images/FUNHIW/price-3290.png" alt="livaABC">
            </div>
            <div class="w-full md:w-1/3 p-2 md:p-3">
              <img class="object-contain" src="~@/assets/images/FUNHIW/price-4550.png" alt="livaABC">
            </div>
          </div>
          <p class="text-center text-sm mb-6">*贈品數量有限送完為止，若贈送完畢，以等值贈品替換。本公司保留活動變更及修改的權利。</p>
          <div class="flex justify-center">
            <router-link :to="{ name: 'sale', params: { category: 'magazine' }, query: { tag: 95 } }" class="text-white bg-red-600 px-12 py-2 mx-auto rounded-full text-2xl font-semibold">立即購買</router-link>
          </div>
        </div>
      </section>
      <!-- 六大學習知識點，所有知識一網打盡 -->
      <section class="knowledge bg-white py-6" id="knowledge">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">六大學習知識點，所有知識一網打盡</h5>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full sm:w-1/2 md:w-1/3 flex py-3" v-for="(item, index) in knowledge" :key="index">
              <div class="w-1/3 px-3">
                <img class="object-contain" :src="item.img_url" alt="livaABC">
              </div>
              <div class="w-2/3 px-2">
                <h6 class="text-lg font-semibold text-gray-dark">{{ item.title1 }}<br/>{{ item.title2 }}</h6>
                <p class="text-sm text-gray-main">{{ item.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 讀者見證及老師推薦，FB各大粉絲團好評不斷 -->
      <section class="reader py-6" id="reader">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">讀者見證及老師推薦，<span class="md:hidden"><br/></span>FB各大粉絲團好評不斷</h5>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 px-3 mb-3 md:mb-0">
              <div class="tag h-12">
                <p class="img-title text-2xl rounded-t-full rounded-b-full rounded-bl-none inline-block px-6 font-semibold">知名臉書團購社團</p>
              </div>
              <div class="border-2 border-blue-800 rounded-lg overflow-hidden px-2 bg-white">
                <img class="object-contain" src="~@/assets/images/FUNHIW/soical-mesage.png" alt="livaABC">
              </div>
            </div>
            <div class="w-full md:w-1/2 flex flex-col px-2 justify-between">
              <div class="tag h-12">
                <p class="img-title text-2xl rounded-t-full rounded-b-full rounded-bl-none inline-block px-6 font-semibold">家長回饋</p>
              </div>
              <div class="reader01 mb-4">
                <div class="content border-2 border-blue-800 rounded-lg overflow-hidden px-3 bg-white flex items-center py-3 md:py-4 lg:py-8 justify-end">
                  <div class="w-9/12 pl-4 lg:px-4">
                    <p class="text-blue-800 font-bold text-xl md:text-2xl leading-relaxed">松山 馮先生</p>
                    <p class="font-semibold leading-relaxed text-base">偶然看到接觸到知識大圖解這本雜誌，想說訂來給兒子看，結果沒想到連我自己都愛上這本雜誌了呢(笑)現在親子之間有更多話題，還會考考對方最近新學到的知識。</p>
                  </div>
                </div>
              </div>
              <div class="reader02">
                <div class="content border-2 border-blue-800 rounded-lg overflow-hidden px-3 bg-white flex items-center py-3 md:py-4 lg:py-8">
                  <div class="w-9/12 pr-4 lg:px-4">
                    <p class="text-blue-800 font-bold text-xl md:text-2xl leading-relaxed">板橋 邱小姐</p>
                    <p class="font-semibold leading-relaxed">聽了朋友推薦說知識大圖解雜誌非常的有趣，而且都是以圖像化的方式呈現，簡單易懂全家大小都可以看，實際收到雜誌時真的是被驚艷到了，完全沒想到科學雜誌可以這麼好看！目前一看成主顧，直接訂了三年！</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 科普教學名師景超老師強力推薦 -->
      <section class="teacher bg-white py-6" id="teacher">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">科普教學名師景超老師強力推薦</h5>
          </div>
          <div class="flex border-2 border-blue-800 md:pr-4 rounded-lg -mt-12 overflow-hidden flex-wrap">
            <div class="w-full md:w-1/5 md:relative order-2 md:order-1">
              <img class="object-contain w-1/2 md:w-full md:absolute bottom-0" src="~@/assets/images/FUNHIW/teacher.png" alt="livaABC">
            </div>
            <div class="leading-relaxed w-full md:w-4/5 pr-3 pl-6 pt-12 pb-6 order-1 md:order-2">
              <p class="text-blue-dark font-semibold">「How it works 知識大圖解」是我在書店無意間發現的智慧鑽石！大約三年前，我正在規劃一檔秒懂科學秀，希望用生動活潑的講解方式、搭配多媒體大圖輸出，來解說世界上新奇有趣的科學知識！當我費盡九牛二之力，才發現原來有一本雜誌早就把我想完成的夢想徹底實現了！在此向各位朋友分享以下三個我推薦這套雜誌的原因：</p>
              <ul class="mb-2">
                <li>一、由英國權威科學機構，網羅世界各地專家彙整分析最新科技與知識！專業度值得信賴！</li>
                <li>二、圖文並茂、次序邏輯分明的解說風格，大大降低閱讀難度！非常適合科普學習者閱讀！</li>
                <li>三、涵蓋工程科技、自然科學、宇宙天文、人文歷史、環境議題與生物知識...各個面向的主題，完全符合108課綱多元探索的精神！</li>
              </ul>
              <p>有別與其他科學雜誌，How it works的解說風格與文章特性是以通俗易懂為主，而且結合最新時事與話題！隨意信手拈來其中一篇，都是新鮮感、知識性與易讀性並存的極好教學素材，身為一位老師，這本雜誌的確是我備課與充實知識的好幫手！我非常喜歡「How it works知識大圖解」，也推薦給熱愛學習的你喔！</p>

            </div>
          </div>
        </div>
      </section>
      <!-- 誰適合讀How It Works？ -->
      <section class="suitable py-6" id="suitable">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">誰適合讀How It Works？</h5>
          </div>
          <div class="flex flex-wrap">
            <div class="tools-item w-full md:w-1/4 flex p-2 " v-for="(item, index) in suitableData" :key="index">
              <div class="tools-item-inner rounded-lg w-full overflow-hidden pb-5 ">
                <div class="title text-center text-white py-2 md:py-3 blue-bg">
                  <h5 class="text-3xl lg:text-4xl font-bold tracking-wider">{{ item.title }}</h5>
                </div>
                <div class="py-3 px-3 lg:px-5 bg-white h-32 flex items-center">
                  <p class="blue-text text-lg lg:text-xl font-semibold text-gray-dark">{{ item.word }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <!-- 會考、學測、統測必備，考題命中率超高！ -->
      <section class="HitRate bg-white py-6" id="HitRate">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">會考、學測、統測必備，<span class="md:hidden"><br/></span>考題命中率超高！
            </h5>
          </div>
          <div class="flex flex-wrap border-2 border-green-800 rounded-lg -mt-12 tracking-wider">
            <div class="content w-full md:w-1/2 pt-10 px-6 pb-5 flex flex-col justify-between">
              <div>
                <p class="mb-2 font-semibold whitespace-pre-line">Q：電動牙刷、電動刮鬍刀、無線通訊手機等充電式電子產品，其充電是運用兩組線圈作為非接觸式充電。在充電時，充電電池或其電極沒有直接與外部電源的接線電極接觸。關於該類科技產品應用到的物理原理，最有可能是下列何者？</p>
                <p>(A)電流的磁效應 (B)感應起電 (C)電磁感應 (D)靜電感應</p>
              </div>
              <div class="flex">
                <img class="object-contain h-12" src="~@/assets/images/FUNHIW/202006.png" alt="livaABC">
                <div class="flex flex-col justify-end text-sm px-3 font-semibold">
                  <p>考題精選97學測</p>
                  <p>【<span class="textColorRed">Ans.C</span>】HIW 2020年6月號 P.38</p>
                </div>
              </div>
            </div>
            <div class="content w-full md:w-1/2 pt-5 md:pt-10 px-6 pb-5 flex flex-col justify-between">
              <div class="mb-2">
                <p class="mb-2 font-semibold whitespace-pre-line">Q：下列是四個高中生針對宇宙演化概念的敘述， 哪幾個學生正確？</p>
                <p>甲 ： 宇宙中大多數的恆星，是在大霹靂時一起誕生</p>
                <p>乙 ： 宇宙微波背景輻射比星光還古老</p>
                <p>丙 ： 宇宙誕生後，既不膨脹也不收縮</p>
                <p>丁 ： 若哈伯定律中的哈伯常數越大，則表示宇宙膨脹越快</p>
              </div>
              <div class="mb-2 flex flex-wrap">
                <p class="w-1/2">(A)僅有甲、乙、丙</p>
                <p class="w-1/2">(B)僅有甲、丙</p>
                <p class="w-1/2">(C)僅有甲、丁</p>
                <p class="w-1/2">(D)僅有乙、丁</p>
                <p class="w-1/2">(E)僅有丁</p>
              </div>
              <div class="flex">
                <img class="object-contain h-12" src="~@/assets/images/FUNHIW/201911.png" alt="livaABC">
                <div class="flex flex-col justify-end text-sm px-3 font-semibold">
                  <p>考題精選104學測</p>
                  <p>【<span class="textColorRed">Ans.D</span>】HIW 2019年11月號 P.64~P.65</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 科普知識動動腦，來看你可以答對幾題吧 -->
      <section class="popSscience py-6" id="popSscience">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">科普知識動動腦，<span class="md:hidden"><br/></span>來看你可以答對幾題吧</h5>
          </div>
          <div class="text-center mb-8 tracking-wider text-sm">
            <p class="text-purple-dark font-semibold">從中累積科普知識，大量內容閱讀吸收新知，還能引導學習潛能哦！</p>
            <p>宅在家太久，遇到親朋好友一時不知道如何開話題嗎？那就講講科普冷知識成為社交達人！讓人覺得你不只聰明又幽默哦 (笑)</p>
          </div>
          <div class="flex flex-wrap ">
            <div class="w-full md:w-1/2 pb-6">
              <div class="rounded-l-full rounded-r-full md:rounded-r-none bg-white py-6 px-6 lg:pl-10 mb-6 md:mb-10">
                <p class="text-xl mb-2 font-semibold text-purple-dark">Q：你知道人體內最長的神經為何？</p>
                <p>(A)顏面神經 (B)坐骨神經 (C)迷走神經 (D)橈神經</p>
              </div>
              <div class="px-4 md:pl-10 text-sm tracking-wider">
                <p>【<span class="textColorRed">Ans. B</span>】7月號 P87</p>
                <p>坐骨神經為人體內最長的神經，負責將運動指令傳至屈腿肌肉群。</p>
              </div>
            </div>
            <div class="w-full md:w-1/2 pb-6">
              <div class="rounded-r-full rounded-l-full md:rounded-l-none bg-white py-6 px-6 lg:pr-10 mb-6 md:mb-10">
                <p  class="text-xl mb-2 font-semibold text-purple-dark">Q：你知道獅子鬃毛的作用為何？</p>
                <p>(A)避免曬傷 (B)打鬥中提供保護 (C)吸引母獅 (D)防止蚊蟲叮咬</p>
              </div>
              <div class="px-4 md:pl-10 text-sm tracking-wider">
                <p>【
                  <span class="textColorRed">Ans. C</span>】5月號 P87</p>
                <p>雌獅喜歡有著厚實、暗色長鬃毛的雄獅。如同孔雀的羽毛，強健的鬃毛象徵了可望傳給後代的強健基因。</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 有圖有真相，精彩內頁滿足你的好奇心 -->
      <section class="cuirs py-6" id="cuirs">
        <div class="">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">有圖有真相，<span class="md:hidden"><br/></span>精彩內頁滿足你的好奇心</h5>
          </div>

          <div class="slider-banner relative">
            <swiper :options="cuirsOption" class="swiper" v-if="cuirsData">
              <swiper-slide v-for="item in cuirsData" :key="item.image_url">
                <img :src="item.img_url" class="object-contain w-full h-auto" :alt="item.name">
              </swiper-slide>
              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            </swiper>
            <div class="swiper-button-next swiper-button-next-FUNHIW focus:outline-none cursor-pointer hidden md:block mt-0"></div>
            <div class="swiper-button-prev swiper-button-prev-FUNHIW focus:outline-none cursor-pointer hidden md:block mt-0"></div>
          </div>
        </div>
      </section>
      <!-- 知識大圖解熱銷叢書通通75折 -->
      <section class="sale75 py-6" id="sale75">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">知識大圖解熱銷叢書通通75折</h5>
          </div>
          <div class="flex flex-wrap">
            <div class="w-1/2 md:w-1/4 p-2 lg:p-4" v-for="(item, index) in sale75" :key="index">
              <div class="rounded-lg bg-white py-2 px-3 border-2 border-red-700">
                <div class="item w-full h-full">
                  <div class="square-book mx-auto w-full" style="padding-bottom: 100% !important">
                    <div class="square-img book-shadow" v-lazy:background-image="{ src: item.img_url }" style="padding-bottom: 100% !important"></div>
                  </div>
                </div>
                <div class="text-center mt-3 mb-1">
                  <p class="text-xs font-semibold mb-0">How It Works知識大圖解</p>
                  <p class="text-xs font-semibold">{{ item.name }}</p>
                </div>
                <div>
                  <div class="bgLiveABCRed block text-center rounded-full py-1">
                    <p class="lg:text-lg text-white font-semibold tracking-wider">特價{{ item.fixPrice }}元</p>
                    <p class="text-sm text-yellow-400 line-through">(原價{{ item.price }}元)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-1/2 md:w-1/4 p-3 md:p-4">

              <router-link :to="{ name: 'sale', params: { category: 'magazine' }, query: { tag: 95 } }" class="rounded-lg bg-white h-full flex items-end bgLiveABCRed">
                <img class="object-contain w-full" src="~@/assets/images/FUNHIW/man.png" alt="livaABC">
              </router-link>

            </div>
          </div>
        </div>
      </section>
      <!-- 知識大圖解必入手套書下殺69折 -->
      <section class="sale69 py-6" id="sale69">
        <div class="max-w-6xl px-3 mx-auto">
          <div class="flex justify-center mb-4 lg:mb-6">
            <h5 class="title inline-block px-8 py-2 text-2xl lg:text-3xl rounded-sm font-semibold title-effect w-full md:w-auto text-center">知識大圖解必入手套書下殺69折</h5>
          </div>
          <div class="flex flex-wrap">
            <div class="w-1/2 p-2">
              <img class="object-contain w-full" src="~@/assets/images/FUNHIW/suit.png" alt="livaABC">
            </div>
            <div class="w-1/2 p-2 flex flex-col justify-center font-black">
              <h6 class="text-xl sm:text-2xl lg:text-3xl">How It Works知識大圖解系列套書</h6>
              <p class="text-xl sm:text-2xl lg:text-3xl mb-4">特價 <span class="textColorRed">1,980</span>元(原價2,880元)</p>
              <div class="">
                <router-link :to="{ name: 'sale', params: { category: 'magazine' }, query: { tag: 95 } }" class="text-white bg-red-600 px-6 py-2 rounded-full text-xl md:text-2xl font-semibold inline-block">立即購買</router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import jump from 'jump.js'
export default {
  name: 'FUNHIW',
  metaInfo () {
    return {
      title: '開學Fun一夏 怎Young都便宜',
      titleTemplate: null
    }
  },
  data () {
    return {
      cuirsOption: {
        preloadImages: true,
        updateOnImagesReady: true,
        autoplay: {
          delay: 5000
        },
        slidesPerView: 2,
        centeredSlides: true,
        watchOverflow: true,
        loop: true,
        effect: 'slide',
        allowTouchMove: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1440: {
            autoplay: {
              delay: 5000
            },
            slidesPerView: 1.8,
            loop: true,
            allowTouchMove: true
          },
          576: {
            autoplay: {
              delay: 5000
            },
            slidesPerView: 1,
            loop: true,
            allowTouchMove: true
          }
        }
      },
      knowledge: [
        { img_url: require('@/assets/images/FUNHIW/icon-1.png'), title1: 'SCIENCE', title2: '科學新知', text: '探索地球上神奇的自然奇景與生物萬象' },
        { img_url: require('@/assets/images/FUNHIW/icon-2.png'), title1: 'ENVIRONMENT', title2: '環境生態', text: '探索酷炫裝置與工程奇蹟的運作原理' },
        { img_url: require('@/assets/images/FUNHIW/icon-3.png'), title1: 'TECHNOLOGY', title2: '科技大觀', text: '揭開世上最神奇的物理、化學與生物學新知' },
        { img_url: require('@/assets/images/FUNHIW/icon-4.png'), title1: 'TRANSPORT', title2: '歷史回顧', text: '從最快的汽車到最先進的飛機，應有盡有' },
        { img_url: require('@/assets/images/FUNHIW/icon-5.png'), title1: 'HISTORY', title2: '歷史回顧', text: '追溯過往，了解過去的世界如何運作' },
        { img_url: require('@/assets/images/FUNHIW/icon-6.png'), title1: 'SPACE', title2: '太空探索', text: '徹底了解美妙無比的宇宙世界' }
      ],

      suitableData: [
        { title: '小朋友', word: '培養小小科學家，啟發創意思考能力。' },
        { title: '學生', word: '大量閱讀理科教材，累積科普素養為學測加分。' },
        { title: '普羅大眾', word: '看膩了八卦新聞，想在休閒時為大腦補充養分。' },
        { title: '專業人士', word: '本刊就是你期待已久，兼具深度及話題性刊物。' }
      ],
      cuirsData: [
        { img_url: require('@/assets/images/FUNHIW/01.jpg') },
        { img_url: require('@/assets/images/FUNHIW/02.jpg') },
        { img_url: require('@/assets/images/FUNHIW/03.jpg') },
        { img_url: require('@/assets/images/FUNHIW/04.jpg') },
        { img_url: require('@/assets/images/FUNHIW/05.jpg') },
        { img_url: require('@/assets/images/FUNHIW/06.jpg') },
        { img_url: require('@/assets/images/FUNHIW/07.jpg') },
        { img_url: require('@/assets/images/FUNHIW/08.jpg') }
      ],

      sale75: [
        { img_url: require('@/assets/images/FUNHIW/book-1.png'), name: '世界歷史大圖解', fixPrice: 374, price: 499 },
        { img_url: require('@/assets/images/FUNHIW/book-2.png'), name: '交通科技大圖解', fixPrice: 360, price: 480 },
        { img_url: require('@/assets/images/FUNHIW/book-3.png'), name: '當代科技大圖解', fixPrice: 360, price: 480 },
        { img_url: require('@/assets/images/FUNHIW/book-4.png'), name: '全球武器大圖解', fixPrice: 360, price: 480 },
        { img_url: require('@/assets/images/FUNHIW/book-5.png'), name: '奇妙大自然大圖解', fixPrice: 360, price: 480 },
        { img_url: require('@/assets/images/FUNHIW/book-6.png'), name: '奧妙科學大圖解', fixPrice: 360, price: 480 },
        { img_url: require('@/assets/images/FUNHIW/book-7.png'), name: '太空奧祕大圖解', fixPrice: 360, price: 480 }
      ]
    }
  },
  methods: {
    toPlan () {
      jump('#plan', {
        duration: 500,
        offset: 0
      })
    },

    toFeature () {
      jump('#feature', {
        duration: 500,
        offset: 0
      })
    },

    toReader () {
      jump('#reader', {
        duration: 500,
        offset: 0
      })
    },

    toRecommend () {
      jump('#teacher', {
        duration: 500,
        offset: 0
      })
    },

    tosShow () {
      jump('#cuirs', {
        duration: 600,
        offset: 0
      })
    },

    toBuyAdd () {
      jump('#sale75', {
        duration: 800,
        offset: 0
      })
    },

    toBuyInstance () {
      jump('#plan', {
        duration: 800,
        offset: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  #FUNHIW {
    .flex-1-c {
      flex: 1 1 20%;
    }
    .text-gray-main {
      color: #797979;
    }
    .text-gray-dark {
      color: #434343;
    }
    .banner {
      background: #f39800;
    }
    .nav {
      ul {
        li {
          color: #5e4040;
        }
      }
    }
    .sub-standard {
      background: #eb6100;
      .text {
        color: #fff100;
      }
      hr {
        position: relative;
        border-top-width: 1px !important;
      }
      hr:after {
        content:"";
        position: absolute;
        background:white;
        right: -11px;
        bottom: -5px;
        z-index: 2;
        width: 15px;
        height: 1px;
        transform: rotate(45deg);
      }
    }
    main {
      .title-effect {
        text-shadow: 2px 2px 2px rgba(27, 27, 27, 0.7);
        box-shadow: 2px 2px 2px rgba(27, 27, 27, 0.7);
        color: white;
      }
      .feature {
        .title {
          background: #ff918f;
        }
        .second-title {
          color: #002985;
        }
      }
      .plan {
        background: #ffe999;
        .title {
          background: #f39800;
        }
      }
      .knowledge {
        .title {
          background: #4fc5d6;
        }
      }
      .reader {
        background: #ccd4e7;
        .title {
          background: #002985;
        }
        .img-title {
          background: white;
          color: #002985;
          box-shadow: 2px 2px 2px rgba(150, 150, 150, 1);
        }
        .reader01 {
          height: calc((100% - 3em) * 48/100);
          @media (max-width: 768px) {
            height: auto;
          }
          .content {
            height: 100%;
            background-image: url('~@/assets/images/FUNHIW/father.png');
            background-repeat: no-repeat;
            background-size: 11em;
            background-position: bottom 0 left 0%;
            @media (max-width: 768px) {
              background-size: 10em;
            }
          }
        }
        .reader02 {
          height: calc((100% - 3em) * 48/100);
          @media (max-width: 768px) {
            height: auto;
          }
          .content {
            height: 100%;
            background-image: url('~@/assets/images/FUNHIW/monther.png');
            background-repeat: no-repeat;
            background-size: 11em;
            background-position: bottom 0 right 0%;
            @media (max-width: 768px) {
              background-size: 10em;
            }
          }
        }
      }
      .teacher {
        .title {
          background: #448aca;
        }
        .text-blue-dark {
          color: #478ccb;
        }
      }
      .suitable {
        background: #faccdc;
        .title {
          background: #e5004f;
        }
        .tools-item {
          .tools-item-inner {
            background: #eb6877;
            .title {
              background: #eb6877;
            }
            border: 2px solid #eb6877;
          }
        }
      }
      .HitRate {
        .title {
          background: #009944;
        }
        .content {
          min-height: 18em;
        }
      }
      .popSscience {
        background: #e7ddec;
        .title {
          background: #8957a1;
        }
        .text-purple-dark {
          color: #8c5ba3;
        }
      }
      .cuirs {
        background: #cccccc;
        .title {
          background: #f39800;
        }
        .slider-banner {
          min-height: 10vh;
          @media (min-width: 768px) {
            min-height: 20vh;
          }
          .swiper-button-next-FUNHIW {
            background-image: url('~@/assets/images/FUNHIW/R.png');
            // src\assets\images\FUNHIW\R.png
            background-size: contain;
            background-size: 50px 50px;
            background-position: center;
            width: 6vw;
            height: 100%;
            transform: translateY(-50%);
            right: 22%;
            @media (max-width: 1440px) {
              right: 19%;
            }
          }
          .swiper-button-prev-FUNHIW {
            background-image: url('~@/assets/images/FUNHIW/L.png');
            background-size: contain;
            background-size: 50px 50px;
            background-position: center;
            width: 6vw;
            height: 100%;
            transform: translateY(-50%);
            left: 22%;
            @media (max-width: 1440px) {
              left: 19%;
            }
          }
          .swiper-slide-prev {
            transition: .3s;
            filter: opacity(.3);
            -webkit-filter: opacity(.3);
            margin: 0;
          }
          .swiper-slide-next {
            transition: .3s;
            filter: opacity(.3);
            -webkit-filter: opacity(.3);
            margin: 0;
          }
          .swiper-pagination-bullet {
            width: 7px;
            height: 7px;
          }
          .swiper-pagination-bullet-active {
            opacity: 1;
            background: #e60012;
          }
        }
      }
      .sale75 {
        .title {
          background: #e60012;
        }
        .square-book {
          position: relative;
          width: 90%;
          padding-bottom : 90%;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          .square-img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            padding-bottom : 90%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
          }
          .playerIcon-preview {
            top: 50%;
            transform: translateY(-50%);
            ul {
              li {
                a {
                  width: 90px;
                  height: 90px;
                }
              }
            }
          }
        }
      }
      .sale69 {
        background: linear-gradient(to bottom, #e9f3d2 80%, #f39800 30%);
        @media (max-width: 1024px) {
          background: linear-gradient(to bottom, #e9f3d2 75%, #f39800 30%);
        }
        @media (max-width: 768px) {
          background: linear-gradient(to bottom, #e9f3d2 80%, #f39800 30%);
        }
        @media (max-width: 576px) {
          background: linear-gradient(to bottom, #e9f3d2 90%, #f39800 30%);
        }
        .title {
          background: #8fc31f;
        }
      }
    }
  }
</style>
